/**
 * Personal profile routes
 */

import RouterUtils from '@/utils/router';
import PersonalProfile from '@/views/profile/PersonalProfile.vue';
import PersonalRecordList from '@/views/profile/PersonalRecordList.vue';

export default [
  {
    path: '/profile',
    component: PersonalProfile,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'profile',
          name: 'Profile',
        });
      },
      () => {
        RouterUtils.markLevelUp({ name: 'dashboard' });
      },
    ],
    props: true,
    children: [
      {
        path: '',
        redirect: { name: 'youthLearningRecord' },
      },
      {
        // TODO: stop using this key to track user records
        path: 'facilitator-training',
        name: 'trainingRecord',
        component: PersonalRecordList,
      },
      {
        path: 'youth-learning',
        name: 'youthLearningRecord',
        component: PersonalRecordList,
      },
      {
        path: 'adult-learning',
        name: 'adultLearningRecord',
        component: PersonalRecordList,
      },
    ],
  },
];
